export default {
  momentLocale: 'pt-br',
  Timeline: {
    expand: 'Expandir',
    fold: 'Recolher',
  },
  Balloon: {
    close: 'Fechar',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  Card: {
    expand: 'Expandir',
    fold: 'Recolher',
  },
  Calendar: {
    today: 'Hoje',
    now: 'Este momento',
    ok: 'Confirmar',
    clear: 'Limpar',
    month: 'Mês',
    year: 'ano',
    prevYear: 'Ano anterior',
    nextYear: 'próximo ano',
    prevMonth: 'Mês Passado',
    nextMonth: 'Próximo mês',
    prevDecade: 'Doze Anos Anteriores',
    nextDecade: 'Passados doze anos',
    yearSelectAriaLabel: 'Selecionar Ano',
    monthSelectAriaLabel: 'Selecione o mês',
    format: {
      months: '1 mês_2 mês_3 mês_4 mês_5 mês_6 mês_7 mês_8 mês_9 mês_10 mês_11 mês_12 mês'.split(
        '_',
      ),
      shortMonths: '1 mês_2 mês_3 mês_4 mês_5 mês_6 mês_7 mês_8 mês_9 mês_10 mês_11 mês_12 mês'.split(
        '_',
      ),
      weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
        '_',
      ),
      shortWeekdays: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
      veryShortWeekdays: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
      yearLabel: 'YYYY',
    },
  },
  DatePicker: {
    placeholder: 'Por favor, selecione uma data',
    datetimePlaceholder: 'Por favor, selecione a data e hora',
    monthPlaceholder: 'Por favor, selecione um mês',
    yearPlaceholder: 'Por favor, selecione o ano',
    now: 'Agora',
    selectTime: 'Escolher Horário',
    selectDate: 'Selecione uma data',
    ok: 'Confirmar',
    clear: 'Limpar',
    startPlaceholder: 'Data inicial',
    endPlaceholder: 'Data de término',
    hour: 'Tempo',
    minute: 'minuto',
    second: 'seg',
  },
  Dialog: {
    close: 'Fechar',
    ok: 'Confirmar',
    cancel: 'Cancelar',
  },
  Message: {
    closeAriaLabel: 'Fechar',
  },
  Pagination: {
    goTo: 'Ir para',
    page: 'Página',
    total: 'Página {current}, de {total}',
    labelPrev: 'Página anterior, página atual {current}',
    labelNext: 'Próxima página, página atual {current}',
    inputAriaLabel: 'Por favor, digite o número da página para saltar',
    selectAriaLabel: 'Selecione quantas entradas mostrar por página',
    pageSize: 'Itens/Página',
  },
  Input: {
    clear: 'Limpar',
  },
  Select: {
    selectPlaceholder: 'Por favor, selecione',
    autoCompletePlaceholder: 'Por favor, insira',
    notFoundContent: 'Sem opções',
    maxTagPlaceholder: '{selected}/{total} itens selecionados',
  },
  Table: {
    empty: 'Sem dados',
    ok: 'Confirmar',
    reset: 'Redefinir',
    asc: 'Ascendente',
    desc: 'Ordem decrescente',
    expanded: 'Expandido',
    folded: 'Recolhido',
    filter: 'Filtrar',
    selectAll: 'Selecionar Todos',
  },
  TimePicker: {
    placeholder: 'Por favor, selecione um horário',
    startPlaceholder: 'Hora de Início',
    endPlaceholder: 'Horário de término',
    clear: 'Limpar',
    hour: 'horas',
    minute: 'min',
    second: 'segundo',
  },

  Transfer: {
    items: 'itens',
    item: 'item',
    moveAll: 'Mover Tudo',
    searchPlaceholder: 'Por favor, insira',
    moveToLeft: 'Desmarcar elemento',
    moveToRight: 'Enviar elementos selecionados',
  },
  Upload: {
    card: {
      cancel: 'Cancelar',
      addPhoto: 'Enviar imagem',
      download: 'Baixar',
      delete: 'Excluir',
    },
    drag: {
      text: 'Clique ou arraste os arquivos para a área de linhas tracejadas para fazer o upload',
      hint: 'Suporte a arquivos do tipo docx, xls, PDF, rar, zip, PNG, JPG, entre outros',
    },
    upload: {
      delete: 'Excluir',
    },
  },
  Search: {
    buttonText: 'Pesquisar',
  },
  Tag: {
    delete: 'Excluir',
  },
  Rating: {
    description: 'Opções de avaliação',
  },
};
